var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.venueCollection.models.length)?_c('ViewFeedItem',{staticClass:"view-feed-userfavoritevenues",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('ViewLayoutModuleHeader',{attrs:{"title":"My favorite places"}},[_c('RouterLink',{attrs:{"to":{
					name: 'PagePlaces',
					query: {
						tab: 'favorites',
					},
				}}},[_c('strong',[_vm._v("View All")])])],1)]},proxy:true},{key:"body",fn:function(){return [_c('ChalkyVenueList',{staticClass:"horizontal",attrs:{"useLocation":true,"venueCollection":_vm.venueCollection},on:{"venue:select":_vm.Handle_OnSelectVenue}})]},proxy:true}],null,false,2250945453)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }